import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import ReactPhoneInput from "react-phone-input-2";

import { PCOperations } from "../../../../../redux/pageConfiguration/pcOperators";

export const PCLaser = ({
  PCInformation,
  setPhone_laser,
  setDisabledButton,
}) => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const checkAvailabilityLaser = async () => {
    if (PCInformation.PCInformation.check_laser === 0) {
      dispatch(
        PCOperations.changeCheckLaser(1, PCInformation.PCInformation.id_user)
      );
    }
    if (PCInformation.PCInformation.check_laser === 1) {
      dispatch(
        PCOperations.changeCheckLaser(0, PCInformation.PCInformation.id_user)
      );
    }
  };

  const handleChange = (e) => {
    setDisabledButton(false);
    setPhone_laser(e, "phone_laser");
  };

  return (
    <>
      <div className="color-border border-div-availabilityCheck availabilityCheck">
        <div className="div-options-form">
          <Form.Check
            onClick={() => checkAvailabilityLaser()}
            type="switch"
            id="custom-switch"
            style={{ height: "2em !important" }}
            className="switch-schedule"
            text="Selecciona si tu negocio dispone de turno intensivo o partido"
            defaultChecked={PCInformation.PCInformation.check_laser}
          />
          <span className="text-color">
            {t("pageConfiguration.customerLaserAvailability")}
          </span>
        </div>
        {PCInformation?.PCInformation?.check_laser === 1 && (
          <Form.Group className="mb-2" id="phone">
            <Form.Label className="size-text-label color-text-secondary">
              {" "}
              {t("profile.textPhoneOtherServices")}{" "}
            </Form.Label>
            <div className="divMyAccount">
              <ReactPhoneInput
                id="idInputPhoneNumberForm"
                className="greyTextFormPhone color-text-secondary bg-input"
                inputExtraProps={{
                  name: "phone_laser",
                  required: true,
                  autoFocus: true,
                }}
                placeholder={t("pageConfiguration.textNewPhone")}
                value={
                  PCInformation.PCInformation?.phone_laser === null
                    ? PCInformation.PCInformation.phone_corporation
                    : PCInformation.PCInformation?.phone_laser
                }
                country="es"
                required
                onChange={(e) => handleChange(e)}
              />
            </div>
          </Form.Group>
        )}
      </div>
    </>
  );
};
